import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { PawnshopPositionEntity, TransactionEntity } from '@generated/gql';
import { AccountStatModel } from '@models/account-stat.model';
import { PawnshopPriceModel } from '@models/pawnshop-price.model';
import { Observable, EMPTY, expand, reduce, of } from 'rxjs';

const MAIN_API_SERVER_URL = environment['MAIN_API_SERVER_URL'] ?? 'http://localhost:3000';

@Injectable({
  providedIn: 'root',
})
export class ProxySubgraphService {
  constructor(private http: HttpClient) {}

  pawnshopPositions$(): Observable<PawnshopPositionEntity[]> {
    const first = 5000;
    let skip = 0;
    // return this.pawnshopPositionsQuery$(1000, 0);
    // return this.pawnshopPositionsQuery$(200, 2000);
    return this.pawnshopPositionsQuery$(first, 0).pipe(
      expand(data => {
        if (data.length !== 0) {
          skip += first;
          return this.pawnshopPositionsQuery$(first, skip);
        }
        return EMPTY;
      }),
      reduce((acc: PawnshopPositionEntity[], data: PawnshopPositionEntity[]) => acc.concat(data), []),
    );
  }

  allTransactions$(): Observable<TransactionEntity[]> {
    const first = 10000;
    let skip = 0;
    return this.transactionsQuery$(first, 0).pipe(
      expand(data => {
        if (data.length !== 0) {
          skip += first;
          return this.transactionsQuery$(first, skip);
        }
        return EMPTY;
      }),
      reduce((acc: TransactionEntity[], data: TransactionEntity[]) => acc.concat(data), []),
    );
  }

  allFormattedTransactions$(): Observable<Record<number, Record<string, string>>> {
    // return this.http.get<Record<number, Record<string, string>>>(`${PROXY_SUBGRAPH_SERVER_URL}/transactions-formatted`);
    return of({});
  }

  allMinPricePawnshop$(): Observable<Record<string, number>> {
    return this.http.get<Record<string, number>>(`${MAIN_API_SERVER_URL}/pawnshop/price-min-data`);
  }

  minPriceByItemId(itemId: string): Observable<PawnshopPriceModel> {
    return this.http.get<PawnshopPriceModel>(`${MAIN_API_SERVER_URL}/pawnshop/price-min-data/${itemId}`);
  }

  accountStat(account: string): Observable<AccountStatModel> {
    return this.http.get<AccountStatModel>(`${MAIN_API_SERVER_URL}/user-stat/${account}`);
  }

  private transactionsQuery$(first: number = 1000, skip: number = 0): Observable<TransactionEntity[]> {
    // return this.http.get<TransactionEntity[]>(`${PROXY_SUBGRAPH_SERVER_URL}/transactions?first=${first}&skip=${skip}`);
    return of([]);
  }

  private pawnshopPositionsQuery$(first: number = 1000, skip: number = 0): Observable<PawnshopPositionEntity[]> {
    return this.http.get<PawnshopPositionEntity[]>(
      `${MAIN_API_SERVER_URL}/pawnshop/positions?first=${first}&skip=${skip}`,
    );
  }
}
